var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.doneMounting)?_c('div',{class:_vm.schema?.cssClass},[(true)?_c('FormEditor',{on:{"change":_vm.onUpdateForm}}):_vm._e(),_c('ComponentTree',{key:_vm.schema?.lastUpdate || 1,attrs:{"node":_vm.schema?.elements,"componentType":_vm.schema?.componentType,"nodeUUID":_vm.schema?.nodeUUID}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }